export default {
  COVER: "cover",
  CONTAIN: "contain"
};
